module.exports = __webpack_public_path__ + "img/pptx.916a571c.svg";